export default "__VITE_ASSET__f3a6ea52__"